import { useNavigation } from '#app/hooks/useNavigation.js';
import { type To } from '#app/types/router.js';
import { useMount } from '@contra/react-hooks/useMount';

type RedirectProps = {
  /**
   * Use replace when the route containing the redirect should not be added to the browser history. This will permit a user to return to route A from route C in A => B (route with redirect) => C.
   *
   * Example: /projects => /me (redirect with replace method) => /@username, where browser history will be /projects => /@username
   */
  readonly method: 'push' | 'replace';
  readonly to: To;
};

export const Redirect = ({ method, to }: RedirectProps) => {
  const navigation = useNavigation();

  useMount(() => {
    navigation[method](to);
  });

  return null;
};
